// ZEDCertification.jsx
import React from "react";

export default function ZEDCertification() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            ZED Certification
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            ZED Certification for MSME Quality & Sustainability
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks supports MSMEs in obtaining ZED Certification
            for quality, energy efficiency, and sustainability standards under
            the Zero Defect Zero Effect scheme.
          </p>
          <p className="text-gray-700">
            From self-assessment guidance and gap analysis to documentation
            preparation, empanelled auditor coordination, and bronze/silver/gold
            certification, the process builds sustainable competitiveness.
          </p>
        </div>

        {/* Right: Image (square for consistency - Different image) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3183152/pexels-photo-3183152.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="MSME factory achieving ZED certification standards"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for ZED Certification
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks assists MSMEs in organizing documentation for
              ZED certification across quality, energy, environment, and
              performance pillars.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>MSME registration certificate (Udyam Aadhaar or Udyog Aadhaar).</li>
                <li>
                  Process and quality documentation including SOPs, quality
                  manuals, inspection records, and defect management systems.
                </li>
                <li>
                  Business details covering manufacturing processes, energy
                  consumption data, environmental compliance, and performance
                  metrics.
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm specializes in ZED certification for MSMEs with expertise
              across all certification pillars and levels.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  MSME Quality Compliance Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Specialized knowledge of ZED model covering quality
                  management, energy optimization, environmental sustainability,
                  and business performance for MSME competitiveness.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Structured Certification Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete guidance through ZED pillar-wise self-assessment,
                  gap analysis, documentation, empanelled auditor liaison, and
                  certification achievement at bronze/silver/gold levels.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Trusted Professional Guidance
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end MSME support from eligibility verification through
                  certification portal registration, audit preparation,
                  corrective actions, and ongoing Zero Defect Zero Effect
                  compliance advisory.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
